var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AccountOpePanel',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"mb-0 h6"},[_vm._v(_vm._s(_vm.$t("通知")))]),_c('messageList')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }